import { getProduct } from '../../product-catalog/productPresentation';

export const programs = [
  { id: 'hi-cps', productId: 'hi-cps', action: getProduct('hi-cps').actions[0] },
  { id: 'pg-solution', productId: 'pg-solution', action: getProduct('pg-solution').actions[0] },
  { id: 'hi-link', productId: 'hi-link', action: { ...getProduct('hi-link').actions[0], label: 'download' } },
  { id: 'tms', name: 'TMS', action: { disabled: true, label: 'comingSoon' } },
];
